export const savedInvestigationGroups = [
  {
    label: "CT",
    options: [
      { label: "Abdo", value: "CT-Abdo" },
      { label: "Brain", value: "CT-Brain" },
      { label: "Chest", value: "CT-Chest" },
      { label: "Limb", value: "CT-Limb" },
      { label: "Spine", value: "CT-Spine" },
    ],
  },
  {
    label: "Pathology",
    options: [{ label: "Pathology", value: "Pathology-Pathology" }],
  },
  {
    label: "Ultrasound",
    options: [{ label: "Ultrasound", value: "Ultrasound-Ultrasound" }],
  },
  {
    label: "X-Ray",
    options: [
      { label: "Chest", value: "X-Ray-Chest" },
      { label: "Limb", value: "X-Ray-Limb" },
      { label: "Spine", value: "X-Ray-Spine" },
    ],
  },
];

const flattenedSavedInvestigations = savedInvestigationGroups.flatMap((group) =>
  group.options.map((option) => ({
    groupLabel: group.label,
    optionLabel: option.label,
    optionValue: option.value,
  }))
);

const findSavedInvestigation = (value: string) => {
  if (!value) return undefined;
  const trimmed = value.trim();
  return flattenedSavedInvestigations.find(
    ({ groupLabel, optionLabel, optionValue }) =>
      trimmed === optionValue || trimmed === `${groupLabel} - ${optionLabel}`
  );
};

export const formatSavedInvestigation = (value: string) => {
  const match = findSavedInvestigation(value);
  if (match) {
    return `${match.groupLabel}: ${match.optionLabel}`;
  }
  if (!value) return "";
  if (value.includes(" - ")) {
    const [group, option] = value.split(" - ");
    if (!option) {
      return group;
    }
    return `${group}: ${option}`;
  }
  return value;
};

export const getSavedInvestigationOptionValue = (value: string) => {
  if (!value) return "";
  const match = findSavedInvestigation(value);
  if (match) {
    return match.optionValue;
  }
  return value.trim();
};

export const getSavedInvestigationOptionLabel = (value: string) => {
  const match = findSavedInvestigation(value);
  if (match) {
    return match.optionLabel;
  }
  if (!value) return "";
  if (value.includes(" - ")) {
    return value.split(" - ").slice(-1)[0].trim();
  }
  return value;
};
